export enum GrantType {
  AuthorizationCode= "AUTHORIZATION_CODE"
}